import Copyright from "./copyright-text";

const TrueSourceDisclaimer = () => (
    <section id="true-source-disclaimer">
        <div className="container-fluid my-5">
            <div className="row justify-content-center align-items-center">
                <div className="col-md-6 col-8">
                    <p className="small text-muted text-center">
                        This product is not intended to diagnose, treat, cure, or prevent any disease.
                        It is not a substitute for professional medical advice, diagnosis, or treatment.
                        Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.
                    </p>
                    <p className="small text-muted text-center">
                        <Copyright />
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default TrueSourceDisclaimer;